/* unplugin-vue-components disabled */import script from "./ResourceConstruction.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceConstruction.vue?vue&type=script&setup=true&lang=js"

import "./ResourceConstruction.vue?vue&type=style&index=0&id=f6a13042&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6a13042"]])

export default __exports__